
      import WechatPayText from './wechat-pay-text.vue'
      import type { App, Plugin } from 'vue'

      export const WechatPayTextPlugin: Plugin = {
        install(app: App) {
          app.component('WechatPayText', WechatPayText)
        },
      }
      export { WechatPayText }
      